import { render, staticRenderFns } from "./CustomTags.vue?vue&type=template&id=ed384186&"
import script from "./CustomTags.vue?vue&type=script&lang=js&"
export * from "./CustomTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports